import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProductUsageGuides } from "../../constants";
import { UsageGuide } from "../../productUsageGuides.types";

export const requestDeleteUsageGuideFaqItem = async (
  faqItemId: string
): Promise<UsageGuide> => {
  return await instance.delete(
    buildUrl(ApiRoutesProductUsageGuides.FaqItems, faqItemId)
  );
};
